module.exports = __webpack_public_path__ + "img/sheetdouble.2f0a06a7.png";